export const SERVER_URL = '';
export const APPLICATION_NAME = 'access';

/**
 * Constants to track session keys for various pages.
 *
 * Semantics
 * - <application name>__<page name>__<description>
 * - hyphen separater for spaced words
 */
export const SessionKeys = {
	/**
	 * Tracks the user's selected filters and sorts on the customer list page
	 */
	customerListPageConfig: `${APPLICATION_NAME}__customer-list-page__config`,
	/**
	 * Tracks the user's selected filters and sorts on the customer application list page
	 */
	customerApplicationListPageConfig: `${APPLICATION_NAME}__customer-application-list-page__config`,
};


export const Urls = {
	SampleCreditReport: "https://drive.google.com/drive/folders/1L-7b_FJhX93pfYA79UxlP7Q3wf4S0qQi"
}
